/**
 * CountDown Timer
 */

export default function HWY_CountDown() {
  const selectors = {};

  this.init = () => {
    if (jQuery(".hwy__countdown-timer").length) {
      jQuery(".hwy__countdown-timer").each(function () {
        const timer = jQuery(this);
        const el = timer.find(".countdown__timer");
        let event_start_time = el.data("event_start_date");
        let event_end_time = el.data("event_end_date");
        let schedule = el.data("schedule");
        const currentTime = new Date();

        if (schedule === "One Time Schedule") {
          if (!event_start_time || !event_end_time) return;

          const countDownStartDate = new Date(event_start_time);
          const countDownEndDate = new Date(event_end_time);
          if (currentTime.getTime() - countDownStartDate.getTime() < 0) {
            jQuery(this).hide();
            return;
          }

          const offset = countDownEndDate.getTime() - currentTime.getTime();
          startCountDown(offset, timer);
        } else if (schedule === "Day") {
          let endTime = new Date();
          endTime.setHours(23, 59, 59, 999);

          const offset = endTime.getTime() - currentTime.getTime();
          startCountDown(offset, timer);
        } else if (schedule === "Week") {
          let endTime = new Date();
          endTime.setHours(23, 59, 59, 999);

          const dayOffset = 7 - currentTime.getDay();
          endTime.setDate(currentTime.getDate() + dayOffset);

          const offset = endTime.getTime() - currentTime.getTime();
          startCountDown(offset, timer);
        } else if (schedule === "Month") {
          let endTime = new Date();
          endTime.setMonth(currentTime.getMonth() + 1);
          endTime.setDate(0);
          endTime.setHours(23, 59, 59, 999);

          const offset = endTime.getTime() - currentTime.getTime();
          startCountDown(offset, timer);
        } else if (schedule == "Coming soon") {
          if (!event_start_time || !event_end_time) return;

          const startDate = new Date(event_start_time);
          const endDate = new Date(event_end_time);
          if (currentTime.getTime() - endDate.getTime() > 0) {
            jQuery(this).hide();
            return;
          }
          const offset = endDate.getTime() - currentTime.getTime();
          startCountDown(offset, timer);
        }
      });
    }
  };

  const startCountDown = (offset, el) => {
    if (offset <= 0) {
      jQuery(el).hide();
      return;
    }

    updateCountDown(offset, el);
    el.slideDown();

    const timer = setInterval(function () {
      updateCountDown(offset, el);
      offset -= 1000;
      if (offset < 0) {
        clearInterval(timer);
        el.slideUp();
        setTimeout(function () {
          el.remove();
        }, 500);
      }
    }, 1000);
  };

  const updateCountDown = (offset, el) => {
    // Time calculations for days, hours, minutes and seconds
    const days = Math.floor(offset / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (offset % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((offset % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((offset % (1000 * 60)) / 1000);
    // Output the result in an element with id="demo"
    el.find(".days").text((days < 10 ? "0" : "") + days);
    el.find(".hours").text((hours < 10 ? "0" : "") + hours);
    el.find(".minutes").text((minutes < 10 ? "0" : "") + minutes);
    el.find(".seconds").text((seconds < 10 ? "0" : "") + seconds);
  };
}
